import { parseWalletLine } from './ownedWallets';

/**
 * Lowercase 0x contract addresses on Cronos whose **incoming** token transfers are treated as
 * taxable **income** (staking rewards, protocol emissions) once EUR FMV is applied — not as a generic purchase.
 *
 * Empty by default: add addresses in code and/or via the Crypto Tax Finland UI (merged at runtime).
 */
export const CRONOS_INCOME_PAYOUT_CONTRACTS = new Set<string>([
  // Example placeholders (comment-only — add real addresses from your history):
  // '0x1234567890123456789012345678901234567890',
]);

/**
 * Built-in defaults plus one optional `0x…` or `Label|0x…` line per row from the UI.
 */
export function mergeIncomePayerContracts(
  userLines: string[] | undefined | null
): Set<string> {
  const out = new Set<string>(CRONOS_INCOME_PAYOUT_CONTRACTS);
  if (!userLines?.length) return out;
  for (const line of userLines) {
    const w = parseWalletLine(line);
    if (w) out.add(w.address);
  }
  return out;
}

export function isCronosIncomePayoutContract(
  contractAddress: string | undefined,
  incomePayers: Set<string>
): boolean {
  if (!contractAddress) return false;
  const c = contractAddress.trim().toLowerCase();
  return c.startsWith('0x') && incomePayers.has(c);
}
